module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-logo-3-ad07e5ea509ad7e1e801cce0301db057.png";